import { Component, Input } from '@angular/core';
import { GraphContainer } from 'src/app/model/generic-graph';

@Component({
  selector: 'app-horizontal-view',
  templateUrl: './horizontal-view.component.html',
  styleUrls: ['./horizontal-view.component.scss']
})
export class HorizontalViewComponent {
  @Input() graphData!: GraphContainer;
  @Input() withGestures: boolean = true;
  public selectedItem: String = '';

  constructor() { }

  public barClick(title: String): void {
    this.selectedItem = title;
  }
}
